import {
  initialState,
  Actions,
  State,
  GET_LAST_INSPECTION,
  GET_LAST_INSPECTION_SUCCESS,
  GET_LAST_INSPECTION_ERROR,
  RESET_GET_LAST_INSPECTION,
} from '../../types/inspection/get-last'

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case GET_LAST_INSPECTION:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      }
    case GET_LAST_INSPECTION_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      }
    case GET_LAST_INSPECTION_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: action.payload,
          success: false,
        },
      }
    case RESET_GET_LAST_INSPECTION:
      return initialState
    default:
      return state
  }
}

export default reducers
